<!-- form panel -->
<div class="card mb-0">
    <div class="card-header">
        <button class="btn btn-light btn-xs" (click)="expanded = !expanded">
            @if (expanded) {
            <span class="dripicons-chevron-up"></span>
            }
            @if (!expanded) {
            <span class="dripicons-chevron-down"></span>
            }
        </button>{{ words[language][ 'communications' ] }}
        <span class="badge badge-info ml-1">{{communicationsList ? communicationsList.length : ''}}</span>

        <button type="button" class="btn btn-sm btn-primary float-right" data-toggle="modal" data-target="#communications" (click)="reset()" title="Add" [disabled]="contactId == 0">Add</button>
    </div>
    @if (expanded) {
    <div>
        <div class="card-body">
            <div class="row text-dark">
                <!-- Comms on Sale Create -->
                @if (isFlat && !communicationUpdate) {
                <section class="col-12">
                    <form [formGroup]="form">
                        <ng-container formArrayName="methods">
                            @for (methodForm of methods.controls; track methodForm; let i = $index) {
                            <div>
                                <div class="row mx-0" [formGroup]="methodForm">
                                    <div class="form-group col-md-3 col-sm-12">
                                        <label for="firstName">{{ words[language][ 'type' ] }}</label>
                                        <select class="custom-select custom-select text-capitalize" formControlName="type" id="new-communication-type-{{i}}">
                                            @for (type of types; track type) {
                                            <option [value]="type" class="text-capitalize">{{words[language][ type ] }}</option>
                                            }
                                        </select>
                                    </div>
                                    <!-- value input -->
                                    <div class="form-group col-md-3 col-sm-12">
                                        <label for="Value">{{ words[language][ 'value' ] }}</label>
                                        <input class="form-control" type="text" id="new-communication-value-{{i}}" formControlName="value" placeholder="{{ words[language][ 'valuePlaceHolder' ] }}" autocomplete="address-level1">
                                        @if (methodForm.get('value').invalid && methodForm.get('value').dirty) {
                                        <span class="text-danger">{{
                                            words[language][ 'invalidValue' ] }}</span>
                                        }
                                    </div>
                                    <div class="form-group col-md-3 col-sm-12">
                                        <label for="subtypes">Subtype</label>
                                        <select class="custom-select custom-select text-capitalize" formControlName="subtype" id="new-communication-subtype-{{i}}">
                                            @for (subtype of subtypes; track subtype) {
                                                <option [value]="subtype" class="text-capitalize"> {{subtype}}</option>
                                            }
                                        </select>
                                    </div>
                                    <!-- icons -->
                                    <div class="col-sm-3 d-flex align-items-center justify-content-center">
                                        <!-- discard -->
                                        @if ((methods.length > 0) && !loading) {
                                            <button type="button" class="btn btn-warning btn-sm m-1" (click)="discard(i)">Remove</button>
                                        }
                                    </div>
                                </div>
                            </div>
                            }
                            <button type="button" class="btn btn-success btn-sm" (click)="add($event)" id="addMethod"><span class="dripicons-plus"></span> {{words[language].addAnother}}</button>
                        </ng-container>
                        <!--  -->
                        <div class="col-md-12 d-flex align-items-center justify-content-center">
                            <!-- save button -->
                            <button class="btn btn-success" id="btn-save-communications-new" (click)="save()" [class.d-none]="isFlat" [disabled]="form.invalid || loading">
                                @if (loading) {
                                <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                                }
                                {{ words[language][ 'save' ] }}</button>
                        </div>
                    </form>
                </section>
                }
                <!-- Comms on Sale Update -->
                @if (isFlat && communicationUpdate) {
                <section class="col-12">
                    <form [formGroup]="modForm">
                        <div class="row">
                            <div class="form-group col-md-4 col-sm-12" [ngClass]="{'col-md-6': isFlat}">
                                <label for="firstName">{{ words[language][ 'type' ] }}</label>
                                <select class="custom-select custom-select text-capitalize" formControlName="type" id="type">
                                    @for (type of types; track type) {
                                    <option [value]="type" class="text-capitalize">{{
                                        words[language][ type ] }}</option>
                                    }
                                </select>
                            </div>
                            <div class="form-group col-md-4 col-sm-11" [ngClass]="{'col-md-6': isFlat}">
                                <label for="Value">{{ words[language][ 'value' ] }}</label>
                                <input class="form-control" type="text" id="Value" formControlName="value" placeholder="{{ words[language][ 'valuePlaceHolder' ] }}" autocomplete="address-level1">
                                @if (value.invalid && value.dirty) {
                                <span class="text-danger">{{ words[language][
                                    'invalidValue' ] }}</span>
                                }
                            </div>
                            <div class="col-sm-4 d-flex align-items-center justify-content-center" [ngClass]="{'col-md-12': isFlat}">
                                <button class="btn btn-success" (click)="modifyCommunication()" [disabled]="modForm.invalid || loading">
                                    @if (loading) {
                                    <span class="spinner-grow spinner-grow-sm" role="status"></span>
                                    }
                                    Update</button>
                                <button class="btn btn-light" (click)="reloadCommunication()">{{
                                    words[language][ 'cancel' ] }}</button>
                            </div>
                        </div>
                    </form>
                </section>
                }
                <!-- Comms on Contact Detail -->
                @for (communication of communicationsList; track communication; let i = $index) {
                    <div class="col-md-12 col-sm-12" [ngClass]="{'col-md-6': isFlat}">
                        <div class="card border ribbon-box">
                            @if (communication.primary) {
                                <div class="ribbon-two ribbon-two-primary"><span>{{ words[language][ 'primary' ] }}</span></div>
                            }
                            <div class="card-header">
                                <!-- 
                                    <div class="m-1 custom-control custom-checkbox custom-control-inline" (click)="selectDefault(communication,communication.type)">
                                        <input type="checkbox" class="custom-control-input" id="'communication_'+{{communication.id}}" [checked]="communication.primary==1">
                                        <label class="custom-control-label text-capitalize font-weight-bold" for="communication_'+{{communication.id}}">{{ words[language][ communication.type ] }}</label>
                                    </div> 
                                -->
                                <div class="font-weight-bold text-center text-capitalize">
                                    {{ communication.subtype ? communication.subtype : communication.type }}
                                </div>
                            </div>
                            <div class="card-body">
                                <table>
                                    <tbody>
                                        <tr>
                                            @if (communication.type === 'phone') {
                                                <td><a href="tel:{{communication.value}}">{{ communication.value | phone }}</a></td>
                                            }
                                            @else if (communication.type === 'email') {
                                                <td><a href="mailto:{{communication.value}}">{{communication.value}}</a></td>
                                            }
                                            @else if (communication.type === 'facebook') {
                                                <td><a href="https://www.facebook.com/{{communication.value}}" target='_blank'>{{communication.value}}</a></td>
                                            }
                                            @else if (communication.type === 'website') {
                                                <td><a target="_blank" href="https://{{communication.value}}">{{communication.value}}</a></td>
                                            }
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer text-center">
                                @if (!isFlat) {
                                    <button class="btn btn-sm text-dark" data-toggle="modal" title="Edit" data-target="#updateCommunicationModal" (click)="selectCommunicationUpdate(communication)">Edit</button>
                                }
                                @if (!isFlat) {
                                    <button class="btn btn-sm text-danger" data-toggle="modal" title="Delete" data-target="#deleteCommunicationModal" (click)="selectCommunication(communication)">Delete</button>
                                }
                                @if (isFlat) {
                                    <button class="btn btn-sm text-dark" title="Edit" (click)="selectCommunicationUpdate(communication)">Edit</button>
                                }
                                @if (isFlat && !communicationUpdate) {
                                    <button class="btn btn-sm text-danger" title="Delete" (click)="okToDelete(communication)">Delete</button>
                                }
                                @if (!communication.primary) {
                                    <button class="btn btn-sm text-dark" (click)="selectDefault(communication)" id="'communication_'+{{communication.id}}">Set as Default</button>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    }
</div>

<!-- ?: modals -->
<div id="communications" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="standard-modalLabel">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-light">
                <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'addCommunication' ] }}</h4>
                <button type="button" class="close" data-dismiss="modal" id="close-modal-communications">×</button>
            </div>
            <div class="modal-body">
                <!-- body -->
                <form [formGroup]="form">
                    <ng-container formArrayName="methods">
                        @for (methodForm of methods.controls; track methodForm; let i = $index) {
                            <div>
                                <div class="row mx-0" [formGroup]="methodForm">
                                    <!-- type select-->
                                    <div class="form-group col-md-3 col-sm-12">
                                        <label for="type">{{ words[language][ 'type' ] }}</label>
                                        <select class="custom-select custom-select text-capitalize" formControlName="type" (change)="clearSubTypeForm(i)">
                                            @for (type of types; track type) {
                                                <option [value]="type" class="text-capitalize">{{type}}</option>
                                            }
                                        </select>
                                    </div>
                                    <!-- value input -->
                                    <div class="form-group col-md-3 col-sm-11">
                                        <label for="Value">{{ words[language][ 'value' ] }}</label>
                                        <input class="form-control" type="text" id="new-communication-value-{{i}}" formControlName="value" placeholder="{{ words[language][ 'valuePlaceHolder' ] }}" autocomplete="address-level1" [email]="methodForm.get('type').value=='email'" [minlength]="methodForm.get('type').value=='phone' ? 10 : 1">
                                        @if (methodForm.get('value').invalid && methodForm.get('value').dirty) {
                                            <span class="text-danger">{{words[language][ 'invalidValue' ] }}</span>
                                        }
                                    </div>
                                    <div class="form-group col-md-3 col-sm-12 m-0 px-0">
                                        <label for="subtypes">Subtype</label>
                                        <select class="custom-select custom-select text-capitalize" formControlName="subtype" id="new-communication-subtype-{{i}}">
                                            @for (subtype of subtypes; track subtype) {
                                                <option [value]="subtype" class="text-capitalize"> {{subtype}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="col-sm-2 d-flex align-items-center justify-content-center">
                                        <!-- discard -->
                                        @if ((methods.length > 1) && !loading) {
                                            <button type="button" class="btn btn-warning btn-sm m-1" (click)="discard(i)">Remove</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        <button type="button" class="btn btn-success btn-sm" (click)="add($event)" id="addMethod"><span class="dripicons-plus"></span> {{words[language].addAnother}}</button>
                    </ng-container>

                    <!--  -->
                    <div class="modal-footer">
                        <!-- save button -->
                        <button class="btn btn-success" id="btn-save-communications" (click)="save()" [disabled]="form.invalid || loading" [class.d-none]="isFlat">
                            @if (loading) {
                                <span class="spinner-grow spinner-grow-sm" role="status"></span>
                            }
                            {{ words[language][ 'save' ] }}</button>
                        <!-- cancel button -->
                        <button class="btn btn-light" id="btn-cancel-communications" data-dismiss="modal">{{
                            words[language][ 'cancel' ] }}</button>
                    </div>
                </form>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- ! delete modal -->
<div class="modal fade" id="deleteCommunicationModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="dripicons-cross text-danger h1"></span>
                <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
                <span class="text-muted my-3 text-center">{{ words[language][ 'deleteCommunication' ] }}</span>

                <button class="btn btn-danger mt-2" (click)="delete()" [disabled]="loading">
                    @if (loading) {
                        <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{ words[language][ 'yes' ] }}
                </button>
                <!-- <button type="button" class="close d-none" data-dismiss="modal" >×</button> -->
                <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="close-delete-modal-communications">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- todo: update modals -->
<div id="updateCommunicationModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="standard-modalLabel">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-light">
                <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'updateCommunication' ] }}</h4>
                <button type="button" class="close" data-dismiss="modal">×</button>
            </div>
            <div class="modal-body">
                <!-- body -->
                <form [formGroup]="modForm" class="row mx-0">
                    <!-- type select-->
                    <div class="form-group col-md-4 col-sm-11">
                        <label for="firstName">Type</label>
                        <select class="custom-select custom-select mb-1 text-capitalize" formControlName="type" id="type" (change)="clearSubTypeModForm(true,type.value)">
                            @for (type of types; track type) {
                                <option [value]="type" class="text-capitalize">{{type}}</option>
                            }
                        </select>
                    </div>
                    <!-- value input -->
                    <div class="form-group col-md-4 col-sm-11">
                        <label for="Value">{{ words[language][ 'value' ] }}</label>
                        <input class="form-control" [type]="inputType" id="Value" formControlName="value" [email]="type.value=='email'" [minlength]="type.value=='phone' ? 10 : 1" placeholder="{{ words[language][ 'valuePlaceHolder' ] }}" [pattern]="inputPattern">
                        @if (value.invalid && value.dirty) {
                            <span class="text-danger">{{ words[language]['invalidValue' ] }}</span>
                        }
                    </div>
                    <div class="form-group col-md-4 col-sm-11">
                        <label for="subtypes">Subtype</label>
                        <select class="custom-select custom-select text-capitalize" formControlName="subtype" id="subtypes">
                            @for (subtype of subtypes; track subtype) {
                                <option [value]="subtype" class="text-capitalize">{{subtype}}</option>
                            }
                        </select>
                    </div>
                </form>
                <div class="modal-footer">
                    <button class="btn btn-success mr-2" (click)="modifyCommunication()" [disabled]="modForm.invalid || loading">
                        @if (loading) {
                            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                        }
                        Update</button>
                    <!-- cancel button -->
                    <button class="btn btn-light" id="btn-close-communications-update" data-dismiss="modal" (click)="reloadCommunication()">{{words[language][ 'cancel' ] }}</button>
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->